export default {
  get_information: [
    {
      title: "CREATED BY",
      description:
        "WorldCom web application created by Murtaza Hassani. My name is Murtaza Hassani I am a full-stack web developer, and graphic designer, graduated from social hacker’s academy",

      discription1: ` The target of building this application is, to help young
      people. But how? what I mean by building a web
      application? So I had one plan to help young people in the
      world and by showing the usage of the power of
      self-confidence, they can do everything they want and they
      can come over of everything and achieve their goals and
      make this world a better place for living, by helping each
      other taking each other hands, and love each other...`,
    },
  ],
  How_To_Use: [
    {
      title: "How to use WorldCom?",
      description:
        "WorldCom web application created by Murtaza Hassani. My name is Murtaza Hassani I am a full-stack web developer, and graphic designer, graduated from social hacker’s academy",

      discription1: `How to use WorldCom?
      It’s very simple to use world-com! 
      <br />
      Step 1: Go to the this URL and then in this URL you will see two buttons, one for sign-up and one for sign-in, 
      if you already have an account please click on the sign-up button to create an account.
      and if you already have an account please click on the sign-in button and use your email address and password to login into the application.
      Step 2: If you created an account and forgot your password, please create a new account.
      Step 3: To have access to the courses and projects, after singing in click on the sidebar and then click “Get My courses” and then click on the “ReactJs” and then it will open a new page you will see all the courses.
      
      
      
      `,
    },
  ],
};
